import { render, staticRenderFns } from "./particiacoesPublicas.vue?vue&type=template&id=39100310&scoped=true"
import script from "./particiacoesPublicas.ts?vue&type=script&lang=ts&external"
export * from "./particiacoesPublicas.ts?vue&type=script&lang=ts&external"
import style0 from "./particiacoesPublicas.vue?vue&type=style&index=0&id=39100310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39100310",
  null
  
)

export default component.exports